// TODO: Deprecated this Button component, please use the new button (button/v2) component from design system
import React from 'react';
import PrimaryActionButton from './PrimaryActionButton';
import { ArrowUpRight } from 'lucide-react';


interface RedirectButtonProps {
  text: string;
  url: string;
  openInNewTab?: boolean;
  disabled?: boolean;
  className?: string;
}

const RedirectButton: React.FC<RedirectButtonProps> = ({
  text,
  url,
  openInNewTab = false,
  disabled,
  className
}) => {
  const handleClick = () => {
    if (openInNewTab) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  return (
      <PrimaryActionButton
        text={text}
        icon={<ArrowUpRight />}
        iconPosition='right'
        onClick={handleClick}
        disabled={disabled}
        className={className}
        variant='redirect'
      />
  );
};

export default RedirectButton;